import { createAction, props } from '@ngrx/store';
import { TCFTrustInfo, TCFTrustSign } from '@store/reducers/tcf-trust/tcf-trust.reducer';
import { TrustState } from '@store/reducers/trust/trust.reducer';
import { TrustTaxInfoState } from '@store/reducers/trust-tax-info/trust-tax-info.reducer';

export const TrustUpdate = createAction(
  '[Trust] Update Trust State',
  props<{ payload: TrustState }>(),
);
export const TrustTaxUpdate = createAction(
  '[Trust Tax] Update Trust Tax Info State',
  props<{ payload: TrustTaxInfoState }>(),
);
export const TCFTrustInfoUpdate = createAction(
  '[Trust Tax] Update TCF Trust Info State',
  props<{ payload: TCFTrustInfo }>(),
);
export const TCFTrustSignUpdate = createAction(
  '[Trust Tax] Update TCF Trust Sign State',
  props<{ payload: TCFTrustSign }>(),
);
